import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 12.152 12.152"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#",
  "fill-rule": "evenodd",
  d: "M6.076 7.787a1.7 1.7 0 0 1-1.47-2.575L6.94 7.545a1.694 1.694 0 0 1-.864.242zm0-3.422a1.711 1.711 0 0 1 1.711 1.711 1.694 1.694 0 0 1-.242.864L5.212 4.607a1.7 1.7 0 0 1 .864-.242zm6.076 7.182-2.44-2.44a8.061 8.061 0 0 0 2.353-3.031S10.354 1.8 6.076 1.8a5.8 5.8 0 0 0-2.91.763L.6 0 0 .6l2.44 2.44A8.061 8.061 0 0 0 .087 6.076s1.713 4.278 5.989 4.278a5.8 5.8 0 0 0 2.91-.763l2.561 2.561z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };